import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesProductSets } from "../../constants";
import { ProductSetsListItem } from "../../productsSets.types";

export const requestProductSets = async (
  params: GetListRequestParams
): Promise<GetListResponse<ProductSetsListItem>> => {
  return await instance.get(ApiRoutesProductSets.ProductSets, {
    params
  });
};
